import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface RcdaRecommendationProposalDialogData {
  html: string;
}

@Component({
  selector: 'rcda-recommendation-proposal-dialog',
  templateUrl: './rcda-recommendation-proposal-dialog.component.html',
  styleUrls: ['./rcda-recommendation-proposal-dialog.component.scss'],
  standalone: false,
})
export class RcdaRecommendationProposalDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: RcdaRecommendationProposalDialogData,
  ) {}
}
